import { IRouter } from 'components/Router';
import homeRoutes from 'routes/home';
import ssoRoutes from 'routes/sso'

const routes: IRouter[] = [
  ...homeRoutes,
  ...ssoRoutes
];

export default routes;
